module.exports = __webpack_public_path__ + "img/GoldVirtuallyIcon.11790ce6.png";